import { SHELEM_TARGETS, type ShelemTarget } from "@bing/shared";
import { faDigits } from "../i18n/digits";
import { fa } from "../i18n/fa";

/**
 * شلم's MATCH TARGETS as a picker offers them — «۶۶۰ امتیاز» / «۱۲۰۰ امتیاز», the shared list the
 * server's schema and the solo room accept, nothing else. ONE list for the private host's
 * «تنظیمات میز» and the solo start screen (card-67), both drawn by `SegmentedChoice`.
 */
export const SHELEM_TARGET_CHOICES: readonly (readonly [ShelemTarget, string])[] =
  SHELEM_TARGETS.map((n) => [n, fa.shelem.targetOption(faDigits(n))] as const);
